import useAPI from './useAPI'

export default function useEnrollments(paginationParams = null) {
  // Build query parameters for pagination
  const queryParams = paginationParams
    ? [
        { key: 'limit', value: paginationParams.limit || 100 },
        ...(paginationParams.lastEvaluatedKey
          ? [
              {
                key: 'lastEvaluatedKey',
                value: encodeURIComponent(
                  JSON.stringify(paginationParams.lastEvaluatedKey)
                ),
              },
            ]
          : []),
        ...(paginationParams.enrollmentStatus
          ? [
              {
                key: 'enrollmentStatus',
                value: paginationParams.enrollmentStatus,
              },
            ]
          : []),
        ...(paginationParams.filters
          ? [
              {
                key: 'filters',
                value: encodeURIComponent(
                  JSON.stringify(paginationParams.filters)
                ),
              },
            ]
          : []),
      ]
    : null

  const { data, error, mutate } = useAPI('/enrollments', 'get', null, queryParams)

  return {
    items: data?.Items,
    lastEvaluatedKey: data?.LastEvaluatedKey,
    count: data?.Count,
    scannedCount: data?.ScannedCount,
    totalEnrolled: data?.TotalEnrolled,
    isLoading: !data && !error,
    error,
    mutate,
  }
}
